import axios from 'axios'
export default axios.create({
    baseURL: '/', // chỉnh cho đúng API backend của bạn
    headers: { 'Content-Type': 'application/json' }
})
